import { createSelector } from '@reduxjs/toolkit';
import { DialogName, ModalName } from 'app/enums';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { useMemo } from 'react';
import { store } from 'redux/store';

import { entityAdapter } from './adapter';

const modalsState = (state: AppState) => state[EntityStoreName.Modals];

const selectIsOpenFactory = (name: ModalName | DialogName) =>
  createSelector(
    store.getState,
    (state) => !!entityAdapter.getSelectors<AppState>(modalsState).selectById(state, String(name))
  );

const selectModalPayloadFactory = (name: ModalName | DialogName) =>
  createSelector(
    store.getState,
    (state) =>
      entityAdapter.getSelectors<AppState>(modalsState).selectById(state, String(name))?.data
  );

export const modalsSelectorFactory = {
  useIsOpen: (modalName: ModalName | DialogName) =>
    useMemo(() => selectIsOpenFactory(modalName), [modalName]),
  useModalPayload: (modalName: ModalName | DialogName) =>
    useMemo(() => selectModalPayloadFactory(modalName), [modalName]),
};
